<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 ">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4  float-left">Lista Visitas</p>
          <a (click)="createVisita()" class="btn btn-success float-right">
            Crear visita</a
          >
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <input class="form-control" placeholder="Buscar visitas..." />
            </div>
            <div class="col-md-6">
              <!-- <select
                        class="custom-select"
                        id="inputGroupSelect02"
                        (change)="onChange($event.target.value)"
                      >
                        <option value="">Seleccione Vendedor</option>
                        <option
                          *ngFor="let vendedor of users"
                          [value]="vendedor.id"
                        >
                          {{ vendedor.nombres }} {{ vendedor.apellidos }}</option
                        >
                      </select> -->
            </div>
          </div>

          <br />

          <div class="row">
            <div class="col-md-12">
              <table
                class="table table-responsive-sm table-hover table-bordered"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <!-- <th>Foto</th> -->
                    <th>Fecha</th>
                    <th>Detalle</th>
                    <!-- <th>Direccion</th>
                      <th>vendedor</th> -->
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody *ngFor="let visita of visitas; let i = index">
                  <tr>
                    <th scope="row">{{ i + 1 }}</th>
                    <td>

                      {{visita.fecha}}
                    </td>
                    <td>
                      {{visita.detalle}}
                    </td>

                    <td>
                      <button
                        type="button"
                        class="btn btn-default btn-sm"
                        (click)="editModal(client.cliente_id)"
                      >
                        <i
                          class="fa fa-pencil-square-o text-info"
                          style="font-size: 20px"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <p>
                  Mostrando clientes 
                </p>
                <p>
                  Página
                </p> -->
              <!-- <input type="number" style="width: 50px;"
                [(ngModel)]="paginanum" name="home" required min="0" step="1">
                <button (click)="searchPage(paginanum)" >
                 ir
               </button> -->
              <br />
              <!-- <button (click)="prevPage()" [disabled]="!clientes.prev_page_url">
                  Anterior
                </button>
                <button (click)="nextPage()" [disabled]="!clientes.next_page_url">
                  Siguiente
                </button> -->
            </div>
          </div>
          <!-- <p *ngIf="clientService.isLoading">Cargando...</p> -->
        </div>
      </div>
    </div>
  </div>
</div>
